
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/kurslar/filter",
      function () {
        return require("private-next-pages/kurslar/filter.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/kurslar/filter"])
      });
    }
  